import { useMemo } from "react";
import { useTheme } from "@fluentui/react/lib/Theme";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

import { EntityType } from "Model/EntityType";

const classNames = {
  root: `HeaderTitleRoot`,
  breadCrumb: `HeaderBreadCrumb`,
  title: `HeaderTitle`,
  targetLink: `HeaderTargetLink`
};

export function useHeaderTitleStyles(type: EntityType) {
  const { semanticColors, spacing } = useTheme();

  const styles = useMemo(
    () => mergeStyleSets({
      root: [
        classNames.root,
        {
          paddingLeft: spacing.m,
          paddingRight: spacing.s1
        }
      ],
      breadCrumb: [
        classNames.breadCrumb,
        {
          cursor: `pointer`,
          maxWidth: type === EntityType.Contact ? `200px` : `250px`,
          selectors: {
            "& > :first-child": {
              overflow: `hidden`,
              padding: `0 ${spacing.s2} ${spacing.s2} ${spacing.s2}`,
              ":hover": {
                backgroundColor: semanticColors.buttonBackgroundHovered
              }
            },
            "& > :last-child": {
              padding: `0 ${spacing.s2}`
            }
          }
        }
      ],
      title: [
        classNames.title,
        {
          overflow: `hidden`
        }
      ],
      targetLink: [classNames.targetLink, {}]
    }),
    [spacing, semanticColors, type]
  );

  const iconStyles = useMemo(
    () => mergeStyleSets({
      root: {
        fontSize: `20px`,
        padding: `4px ${spacing.s1} 0 ${spacing.s2}`
      }
    }),
    [spacing]
  );

  return { styles, iconStyles };
}
